import React, { Component } from 'react';
import { connect } from 'react-redux';
import './login.scss';
import { Button } from 'antd';
import logo from '../../../images/logo.png';
import { fromValidate } from '../../../helpers';
import { history } from '../../../helpers';
import { Table } from 'antd';
const data = [
	{
		key: '1',
		amount: "100",
		paymentType: "Credit",
		transactedOn: "10-12-2020",
	},
	{
		key: '2',
		amount: "50",
		paymentType: "Credit",
		transactedOn: "09-10-2020",
	},
	{
		key: '3',
		amount: "75",
		paymentType: "Dabit",
		transactedOn: "09-08-2020",
	},
	{
		key: '4',
		amount: "100",
		paymentType: "Dabit",
		transactedOn: "06-04-2020",
	},
];
const creditColumns = [
	{
		title: 'Amount',
		dataIndex: 'amount',
	},
	{
		title: 'Type',
		dataIndex: 'paymentType',
	},
	{
		title: 'Transacted On',
		dataIndex: 'transactedOn',
	},
];
class Credits extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isSuccess: true,
		}
	}



	render() {
		const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
		return (
			<div className='reset-container'>
				<div className='login-box'>
					<div className='upload-heading-txt'>Credits</div>
				</div>
				<Table
					columns={creditColumns}
					dataSource={data}
				/>
				<div className='total-balance-txt'>Balance<span className="balance-amount-txt">&#8377;100</span></div>
			</div>
	
		)
	}
}

function mapStateToProps(state) {
	const { user } = state.authentication;
	return {
		user,
	}
}
export default connect(mapStateToProps)(Credits);